module.exports = __webpack_public_path__ + "static/img/home_logo.1d1014a5.png";